<div class="basicrow container-s">
  <div class="basicrow txt-center addressent">
    <div class="overallpadded-c tabformdef">
      <div class="basicrow">
        <div class="samePlace" *ngIf="this.global.deviceType != 'accessory'">
          <input type="checkbox" value="this.checkInfoHouse" (change)="this.fillData()">
          <a class="servicetermslink cursor">
            Desea recibir el equipo en su mismo lugar de residencia.
          </a>
        </div>
        <form [formGroup]="signupFormUser">
          <div class="grid-addres">
            <div class="tabformside-c">
              <div class="basicrow tabforminp-title">
                Nombre&#42;:
              </div>
              <input required formControlName="name" type="text" class="tabforminp-def-i" maxlength="60">
              <div [hidden]="signupFormUser.controls.name.value || signupFormUser.controls.name.untouched"
                class="alert2 alert-danger  tabforminp-def-iiiii" style=" width: 94% ">
                Nombre Requerido
              </div>
            </div>
            <div class="tabformside-c-i">
              <div class="basicrow tabforminp-title title-floatleft">
                Apellidos&#42;:
              </div>
              <input required formControlName="lastName" type="text" class="tabforminp-def-i tabforminp-def-iiii"
                maxlength="60">
              <div [hidden]="signupFormUser.controls.lastName.value || signupFormUser.controls.lastName.untouched"
                class="alert2 alert-danger tabforminp-def-iiii" style=" width: 94% ">
                Apellido Requerido
              </div>
            </div>
            <div class="tabformside-c">
              <div class="basicrow tabforminp-title">
                Tel&eacute;fono &#42;:
              </div>
              <input required formControlName="phone" type="text" class="tabforminp-def-i" maxlength="10"
                [appOnlyNumber]>
              <div [hidden]="signupFormUser.controls.phone.value || signupFormUser.controls.phone.untouched"
                class="alert2 alert-danger tabforminp-def-iiiii" style=" width: 94% ">
                Telefono Requerido
              </div>
            </div>
            <div class="tabformside-c-i">
              <div class="basicrow tabforminp-title title-floatleft">
                Tel&eacute;fono (2):
              </div>
              <input type="text" class="tabforminp-def-i tabforminp-def-iiii" maxlength="10" [appOnlyNumber]
                formControlName="phone2">
            </div>
            <div class="tabformside-c">
              <div class="basicrow tabforminp-title">Dirección&#42;:</div>
              <div class="ajustwidth">
                <input class="tabforminp-def-i" required formControlName="addres" (keyup)="this.noValid=true"
                  maxlength="200" placeholder="Urb, Barrio, Nombre de edif">
                <div [hidden]="signupFormUser.controls.addres.valid || signupFormUser.controls.addres.untouched"
                  class="alert2 alert-danger tabforminp-def-iiiii" style=" width: 94% ">
                  ingrese una Dirección
                </div>
              </div>
            </div>
            <div class="tabformside-c-i">
              <div class="basicrow tabforminp-title title-floatleft">
                Email&#42;:
              </div>
              <input required formControlName="email" type="text" class="tabforminp-def-i  tabforminp-def-iiii">
              <div [hidden]="signupFormUser.controls.email.value || signupFormUser.controls.email.untouched"
                class="alert2 alert-danger tabforminp-def-iiii" style=" width: 94% ">
                Email Requerido
              </div>
            </div>
            <div class="tabformside-c">
              <div class="basicrow tabforminp-title">Dirección (2):</div>
              <div class="ajustwidth">
                <input class="tabforminp-def-i" formControlName="addres2" maxlength="200"
                  placeholder="Núm de Casa, Apt, Calle, Núm Edif.">
              </div>
            </div>
            <div class="tabformside-c-i">
              <div class="basicrow tabforminp-title title-floatleft ">ZIP Code*:</div>
              <div class="ajustwidth">
                <input class="tabforminp-def-i tabforminp-def-iiii" required formControlName="zip" [appZipCode]
                  minlength="5" maxlength="5" (keyup)="this.noValid=true">
                <div
                  [hidden]="(signupFormUser.controls.zip.valid || signupFormUser.controls.zip.untouched) && this.noValid"
                  class="alert2 alert-danger padSpace tabforminp-def-iiii" style=" width: 94% ">
                  El ZIP Code es requerido y debe pertenecer a un pueblo de PR.
                </div>
              </div>
            </div>
            <div class="tabformside-c">
              <div class="basicrow tabforminp-title">
                Estado&#42;:
              </div>
              <select class="tabforminp-def-i" required formControlName="state">
                <option value="PR"> PR </option>
              </select>
              <div [hidden]="signupFormUser.controls.state.value || signupFormUser.controls.state.untouched"
                class="alert2 alert-danger relative-pos tabforminp-def-iiiii" style=" width: 94%;">
                Estado Requerido
              </div>
            </div>
            <div class="tabformside-c-i">
              <div class="basicrow tabforminp-title title-floatleft">
                Pueblo*:
              </div>
              <input *ngIf="signupFormUser.controls.city.value!=null" readonly
                class="tabforminp-def-i spacing-placeholder tabforminp-def-iiii" required formControlName="city"
                [ngModel]="signupFormUser.controls.city.value">
              <div *ngIf="signupFormUser.controls.city.value!=null"
                [hidden]="(signupFormUser.controls.zip.valid || signupFormUser.controls.zip.untouched) && this.noValid"
                class="alert2 alert-danger padSpace tabforminp-def-iiii" style=" width: 94% ">
                Debe colocar un Zip Code Valido.
              </div>
            </div>
            <div class="tabformside-c">
              <div class="basicrow tabforminp-title ">
                Indicaciones:
              </div>
              <textarea class="tabforminp-def-iii " formControlName="indications"
                placeholder="Detalles, puntos de referencia de direcci&oacute;n o instrucciones que deseas agregar."></textarea>
            </div>
          </div>
        </form>
        <div class="content-display">
          <div class="content-display-child" *ngIf="this.showTerms==true"
            [ngClass]="{'space-text2': this.showTerms==true}">
            <input type="checkbox" [(ngModel)]="this.checkterms">
            <a class="servicetermslink cursor" (click)="this.pupOpTermns()">
              Acepto t&eacute;rminos de Contrato
            </a>
          </div>
          <div class="content-display-child"
            [ngClass]="{'left-size': this.showTerms!=true,'space-text': this.showTerms==true}">
            <input type="checkbox" [(ngModel)]="this.checktermsDevolution">
            <a class="servicetermslink cursor" (click)="this.pupOpTermnsReturn()">
              Acepto Politicas de Devoluci&oacute;n
            </a>
          </div>
        </div>
        <div class="basicrow tabform-m txt-center">
          <div class="btn-continue" (click)="validationAddres();">
            <div class="btntxt din-b">
              CONTINUAR
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
